/**
 * Masks a Flagsmith environment key for display.
 *
 * Kept free of any config import so it can be tested without the app's environment: it is pure
 * presentation.
 *
 * @module Pages/BUs/WhatsNew
 */

/**
 * Shows enough of the key to recognise which environment is in play, without printing it whole.
 *
 * @example maskEnvironmentKey('ser.abcdefghijkl') // 'ser.••••ijkl'
 */
export function maskEnvironmentKey(key: string): string {
  if (key.length <= 8) return key;
  return `${key.slice(0, 4)}••••${key.slice(-4)}`;
}
